var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCrossIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 200,
    zoomAndPan: "magnify",
    viewBox: "0 0 150 149.999998",
    height: 200,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "17a416e0ce"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 0 L 150 0 L 150 149.25 L 0 149.25 Z M 0 0 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#17a416e0ce)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#009cff",
    d: "M 6.503906 149.25 C 4.996094 149.25 3.488281 148.675781 2.339844 147.523438 C 0.0390625 145.226562 0.0390625 141.496094 2.339844 139.199219 L 139.320312 2.304688 C 141.621094 0.00390625 145.351562 0.00390625 147.652344 2.304688 C 149.953125 4.601562 149.953125 8.332031 147.652344 10.628906 L 10.671875 147.523438 C 9.519531 148.675781 8.011719 149.25 6.503906 149.25 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009cff",
    d: "M 143.484375 149.25 C 141.980469 149.25 140.46875 148.675781 139.320312 147.523438 L 2.339844 10.628906 C 0.0390625 8.332031 0.0390625 4.601562 2.339844 2.304688 C 4.640625 0.00390625 8.371094 0.00390625 10.671875 2.304688 L 147.652344 139.199219 C 149.953125 141.496094 149.953125 145.226562 147.652344 147.523438 C 146.503906 148.675781 144.992188 149.25 143.484375 149.25 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossIcon);
export default __webpack_public_path__ + "static/media/cross-icon.bcd1a7fd80868d942518374fd65033f7.svg";
export { ForwardRef as ReactComponent };